// Thai (ไทย). Keys are the English source strings. Brand names stay English.
export const th = {
  "Log in": "เข้าสู่ระบบ",
  "Log out": "ออกจากระบบ",
  "Admin": "แอดมิน",
  "Continue": "ต่อไป",
  "Retry": "ลองใหม่",
  "Back": "ย้อนกลับ",
  "Back to browse": "กลับไปหน้าเรียกดู",

  "Admin access.": "สำหรับแอดมิน",
  "Email": "อีเมล",
  "Password": "รหัสผ่าน",
  "Logging in…": "กำลังเข้าสู่ระบบ…",
  "Not an admin?": "ไม่ใช่แอดมิน?",
  "Enter with your access code": "เข้าใช้งานด้วยรหัสเข้าถึง",

  "Private preview. Your access code opens the loop.":
    "พรีวิวส่วนตัว รหัสเข้าถึงของคุณเปิดลูปนี้",
  "Access code": "รหัสเข้าถึง",
  "Entering…": "กำลังเข้า…",
  "Enter Algorhythmic": "เข้าสู่ Algorhythmic",
  "Your email": "อีเมลของคุณ",
  "Sending…": "กำลังส่ง…",
  "Request access": "ขอสิทธิ์เข้าใช้งาน",
  "You're on the list.": "คุณอยู่ในรายชื่อแล้ว",
  "We'll get back to you soon with your access code at {{email}}.":
    "เราจะส่งรหัสเข้าถึงให้คุณเร็ว ๆ นี้ที่ {{email}}",
  "Back to sign in": "กลับไปหน้าเข้าสู่ระบบ",
  "Don't have an access code?": "ยังไม่มีรหัสเข้าถึง?",
  "Request access code": "ขอรหัสเข้าถึง",
  "Admin login": "เข้าสู่ระบบแอดมิน",
  "Could not reach the server. Check your connection and try again.":
    "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ ตรวจสอบการเชื่อมต่อแล้วลองใหม่",

  "Could not load your episodes. Check your connection, then retry.":
    "โหลดตอนของคุณไม่ได้ ตรวจสอบการเชื่อมต่อแล้วลองใหม่",
  "Resume episode": "ดูตอนต่อ",
  "Play": "เล่น",
  "More info": "ข้อมูลเพิ่มเติม",
  "Continue watching": "ดูต่อ",

  "Could not load this series. Check your connection and try again.":
    "โหลดซีรีส์นี้ไม่ได้ ตรวจสอบการเชื่อมต่อแล้วลองใหม่",
  "Season": "ซีซัน",
  "Season 1": "ซีซัน 1",
  "Paused at {{time}}": "หยุดไว้ที่ {{time}}",
  "Watched": "ดูแล้ว",

  "Could not load this episode. Check your connection and try again.":
    "โหลดตอนนี้ไม่ได้ ตรวจสอบการเชื่อมต่อแล้วลองใหม่",
  "You paused at {{time}}. Pick up where you left off?":
    "คุณหยุดไว้ที่ {{time}} ดูต่อจากตรงนั้นไหม?",
  "Start from beginning": "เริ่มจากต้น",

  "Quick check": "เช็กสั้น ๆ",
  "Not that one. One more try.": "ไม่ใช่อันนั้น ลองอีกครั้ง",
  "Talk it through with Morse. Then try once more.":
    "คุยกับ Morse ดูก่อน แล้วลองอีกครั้ง",
  "Morse has finished. Try once more.": "Morse อธิบายเสร็จแล้ว ลองอีกครั้ง",
  "Correct.": "ถูกต้อง",
  "Not quite.": "ยังไม่ถูก",
  "Could not record your answer. Continue watching. This attempt won't count.":
    "บันทึกคำตอบไม่ได้ ดูต่อได้เลย ครั้งนี้จะไม่นับ",

  "Playback speed": "ความเร็วในการเล่น",
  "Quality": "ความคมชัด",
  "Audio language": "ภาษาเสียง",
  "Subtitles": "คำบรรยาย",
  "Reset quizzes for this episode": "รีเซ็ตแบบทดสอบของตอนนี้",
  "Normal": "ปกติ",
  "Off": "ปิด",
  "More languages coming": "จะมีภาษาเพิ่มเร็ว ๆ นี้",
  "Original audio only": "มีเฉพาะเสียงต้นฉบับ",
  "No subtitles for this episode yet": "ยังไม่มีคำบรรยายสำหรับตอนนี้",
  "This will make all quizzes in this episode appear again. Continue?":
    "การทำแบบนี้จะทำให้แบบทดสอบทั้งหมดในตอนนี้ปรากฏอีกครั้ง ดำเนินการต่อไหม?",
  "Cancel": "ยกเลิก",

  "Language": "ภาษา",

  "Try it": "ลองดู",
  "Check": "ตรวจคำตอบ",
  "Checking…": "กำลังตรวจ…",
  "Take your time": "ค่อย ๆ คิดได้เลย",
  "Clear": "ล้าง",
  "Delete": "ลบ",
  "Show ladder": "แสดงบันได",
  "Hide ladder": "ซ่อนบันได",
  "remainder": "เศษ",
  "Read the remainders from bottom to top.": "อ่านเศษจากล่างขึ้นบน",
  "Convert": "แปลง",
  "Your answer": "คำตอบของคุณ",
  "Target": "เป้าหมาย",
  "Yours": "ของคุณ",
  "Red": "แดง",
  "Green": "เขียว",
  "Blue": "น้ำเงิน",
  "bits": "บิต",
  "Stretch task — no auto-grading yet.": "โจทย์เสริม — ยังไม่มีการตรวจอัตโนมัติ",
  "Reveal solution": "ดูเฉลย",
  "Hide solution": "ซ่อนเฉลย",
  "I finished this": "ฉันทำเสร็จแล้ว",
  "All practice": "แบบฝึกหัดทั้งหมด",
  "Now make it yours": "ถึงเวลาทำให้เป็นของคุณ",
  "Four quick checks, then eight problems. Nothing is timed against you.":
    "เช็กเร็วสี่ข้อ แล้วต่อด้วยโจทย์แปดข้อ ไม่มีการจับเวลากดดันคุณ",
  "Quick checks": "เช็กเร็ว",
  "Practice problems": "โจทย์ฝึก",
  "Watch the episode again": "ดูตอนนี้อีกครั้ง",
  "Decimal": "ฐานสิบ",
  "Tap the powers sitting under the ones.": "แตะค่าประจำหลักที่อยู่ใต้เลข 1",
};
